import type { ReactNode, CSSProperties } from 'react';
import './components.css';

interface CardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  footer?: ReactNode;
  accent?: string;
  actions?: ReactNode;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
  onClick?: () => void;
}

export function Card({
  title,
  subtitle,
  footer,
  accent,
  actions,
  className = '',
  children,
  style,
  onClick,
}: CardProps) {
  const accentStyle = accent
    ? ({ '--card-accent': accent } as CSSProperties)
    : undefined;
  const merged: CSSProperties = { ...accentStyle, ...style };
  return (
    <div
      className={`iris-card ${accent ? 'has-accent' : ''} ${onClick ? 'clickable' : ''} ${className}`}
      style={merged}
      onClick={onClick}
    >
      {(title || actions) && (
        <header className="iris-card-header">
          <div className="iris-card-titles">
            {title && <div className="iris-card-title">{title}</div>}
            {subtitle && <div className="iris-card-subtitle">{subtitle}</div>}
          </div>
          {actions}
        </header>
      )}
      {children && <div className="iris-card-body">{children}</div>}
      {footer && <div className="iris-card-footer">{footer}</div>}
    </div>
  );
}
